import { __assign } from "tslib";
import { useMemo } from "react";
var wrapFunctionWithBucket = function (func, bucketId) {
    if (!func)
        return undefined;
    return function (data) {
        var modifiedData = __assign(__assign({}, data), (bucketId ? { bucket_id: bucketId } : {}));
        return func(modifiedData);
    };
};
export var useBucketAwareApiRef = function (apiRef, bucketId) {
    var apiRefWithBucket = useMemo(function () {
        var _a;
        return ({
            list: wrapFunctionWithBucket(apiRef.list, bucketId),
            get: wrapFunctionWithBucket(apiRef.get, bucketId),
            buckets: apiRef.buckets,
            getArchive: wrapFunctionWithBucket(apiRef.getArchive, bucketId),
            share: apiRef.share
                ? {
                    list: wrapFunctionWithBucket(apiRef.share.list, bucketId),
                    get: wrapFunctionWithBucket(apiRef.share.get, bucketId),
                    delete: wrapFunctionWithBucket((_a = apiRef.share) === null || _a === void 0 ? void 0 : _a.delete, bucketId),
                    create: wrapFunctionWithBucket(apiRef.share.create, bucketId),
                    send: wrapFunctionWithBucket(apiRef.share.send, bucketId),
                }
                : undefined,
            delete: wrapFunctionWithBucket(apiRef.delete, bucketId),
            update: wrapFunctionWithBucket(apiRef.update, bucketId),
            upload: apiRef.upload,
            folderCreate: wrapFunctionWithBucket(apiRef.folderCreate, bucketId),
        });
    }, [apiRef, bucketId]);
    return apiRefWithBucket;
};
